import { render, staticRenderFns } from "./verPropuesta.vue?vue&type=template&id=1f3da05e"
import script from "./verPropuesta.vue?vue&type=script&lang=js"
export * from "./verPropuesta.vue?vue&type=script&lang=js"
import style0 from "./verPropuesta.vue?vue&type=style&index=0&id=1f3da05e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports